import { components } from 'type/ReportServiceSchema';

export type DepartmentDto = components['schemas']['PerspectivesDepartmentDTO'];
export type DepartmentsListResultDto = components['schemas']['PerspectivesDepartmentsListResultDTO'];

export type DepartmentModel = {
  id: number;
  name: string;
  children: DepartmentsListResultModel;
  commentResponses: number;
  arePrerequisitesMet: boolean;
};

export type DepartmentsListResultModel = {
  items: DepartmentModel[];
};

export const mapDepartmentsDtoToModel = (dto: DepartmentDto): DepartmentModel => ({
  id: dto.id,
  name: dto.name,
  children: { items: dto.children.map(mapDepartmentsDtoToModel) },
  commentResponses: dto.commentResponses,
  arePrerequisitesMet: dto.arePrerequisitesMet,
});

export const mapDepartmentsListResultDtoToModel = (
  dto: DepartmentsListResultDto
): DepartmentsListResultModel => ({
  items: dto.items.map(mapDepartmentsDtoToModel),
});

export type PerspectivesDepartmentModel = {
  departmentsList: DepartmentsListResultModel;
  isDepartmentsAvailable: boolean;
};
